import { useContext } from 'react';

import { CheckoutFlowContext, CheckoutFlowContextValue } from '../../CheckoutFlowContext';

export const useCheckoutFlow = (): CheckoutFlowContextValue => {
  return useContext(CheckoutFlowContext);
};
